<template>
    <div>
        <b-row>
            <b-col sm="12">
                <b-table outlined 
                         sticky-column 
                         responsive
                         :fields="fields" 
                         :items="items" 
                         :busy="items == 0"
                         :current-page="currentPage" 
                         :per-page="perPage">
                         <div slot="table-busy" class="text-center my-2">
                            <strong>데이터가 없습니다.</strong>
                        </div>
                </b-table>
            </b-col>
            <b-col sm="12">
                <b-pagination v-model="currentPage" 
                            :totalRows="totalRows" 
                            :per-page="perPage"
                            align="center"></b-pagination>
            </b-col>
        </b-row>
    </div>
</template>
<script>
export default {
    name: "userCouponList",
    props: {
        userId: {
            type: String,
            default: ""
        },
    },
    data() {
        return {
            fields: [
                , { 'coupon_code': { 'label': '쿠폰코드', thClass: 'thClass_w10', tdClass: 'textAlignCenter' } }
                , { 'coupon_name': { 'label': '쿠폰명' , thClass: 'thClass_w50', tdClass: 'tdClass' } }
                , { 'opt_value': { 'label': '할인률', thClass: 'thClass_w10', tdClass: 'textAlignCenter' } }
                , { 'start_date': { 'label': '발행일', thClass: 'thClass_w10', tdClass: 'textAlignCenter' } }
                , { 'end_date': { 'label': '만료일', thClass: 'thClass_w10', tdClass: 'textAlignCenter' } }
                , { 'coupon_pub_status_name': { 'label': '쿠폰상태', thClass: 'thClass_w10', tdClass: 'textAlignCenter' } }
            ],
            items: [],
            currentPage: 1,
            perPage:10,
            totalRows:0,
            formModal: false,
            item: {},
        }
    },
    watch: {
        userId: function (value, oldValue) {
            this.findCouponList();
        },
    },
    methods: {
        findCouponList() {
            var token = sessionStorage.getItem("myToken");
            this.$http.get('/api/select/userCouponList?access_token='+token + '&user_id=' + this.userId)
                .then((result) => {
                const { data } = result;
                this.items = data;
                this.totalRows = this.items.length;
            })
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/views/user/userDetail/component/tabs/coupon/UserCouponList.vue